module.exports = __webpack_public_path__ + "static/media/2.c66d6315.jpg";